export default __webpack_public_path__ + "static/media/pencil.12695113.svg";